<script setup lang="ts" name="BaseLink">
import Icon from '~/components/Icon.vue';

import type { IconType } from '~/types';

const {
  disabled,
  icon = 'mdi:chevron-right',
  loading,
  size = 'sm',
} = defineProps<{
  disabled?: boolean;
  loading?: boolean;
  icon?: IconType | null;
  size?: 'sm' | 'base';
}>();
</script>

<template>
  <div
    class="flex w-full items-center"
    :class="{
      'cursor-pointer text-primary-8 hover:text-primary-6 focus-visible:outline-none focus-visible:ring focus-visible:ring-ocean-3 active:text-ocean-4 group-hover:text-primary-6 group-active:text-ocean-4':
        !disabled,
      'cursor-default text-charcoal-4': disabled,
      'text-loading h-5': loading,
      'text-sm': size === 'sm',
    }"
  >
    <slot />
    <Icon v-if="icon !== null" :icon="icon" class="ml-auto" />
  </div>
</template>
